import { carouselData } from '@/mocks/home';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
              <i className="ri-focus-2-line text-accent-600 text-lg"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              焦点深扒
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer group flex flex-col"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-secondary-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    const parent = target.parentElement;
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}